<main class="dropdown-menu">
  <div class="dropdown-button" (mouseover)="onHoverButton($event)">
    <div class="dropdown-icon">
      <i class="pi" [ngClass]="icon"></i>
    </div>
    <span *ngIf="title">{{ title }}</span>
  </div>
  <div class="dropdown-options" *ngIf="items" [ngClass]="dropdownPosition">
    <ng-container *ngFor="let item of items">
      <span class="group-title">{{ item.label }}</span>
      <ul>
        <li *ngFor="let option of item.items" (click)="option.command()">
          <i *ngIf="option.icon" class="pi" [ngClass]="option.icon"></i>
          <span> {{ option.label }}</span>
        </li>
      </ul>
    </ng-container>
  </div>
</main>
